import {
  ALLOWED_EDD_FILTERS,
  EDD_ALL_SHIPMENTS_QUERY,
  EDD_DATE_RANGE_QUERY,
  EXCLUDE_DELETED_SHIPMENTS_QUERY,
  FILTER_OPTIONS,
  FILTER_OPTION_TO_WHERE_CLAUSE,
  SORT_OPTIONS,
} from '@/modules/pmt/constants';
import { type QueryCompositeFilterConstraint, type QueryFieldFilterConstraint, and } from 'firebase/firestore';

export const allowedSortByEDD = (filter: FILTER_OPTIONS, sort: SORT_OPTIONS): boolean => {
  if (sort !== SORT_OPTIONS.DELIVERY_DATE) return false;

  return ALLOWED_EDD_FILTERS.includes(filter);
};

export const excludeDeleted = (query: QueryFieldFilterConstraint | QueryCompositeFilterConstraint) => {
  return and(EXCLUDE_DELETED_SHIPMENTS_QUERY, query);
};

export const getEddShipmentsQuery = (filter: FILTER_OPTIONS) => {
  if (filter === FILTER_OPTIONS.ALL) {
    return and(EDD_ALL_SHIPMENTS_QUERY, EDD_DATE_RANGE_QUERY);
  }

  return and(FILTER_OPTION_TO_WHERE_CLAUSE[filter], EDD_DATE_RANGE_QUERY);
};
